// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

const validators = {
  required: (
    obj: {[string]: any},
    fields: any,
  ): boolean => fields.every(field => obj[field] !== undefined),
};

const runValidator = (
  name: string,
  constraintData: any,
  obj: any,
): boolean => validators[name](obj, constraintData);

export const validate = (
  obj: {[string]: any},
  constraints: {[string]: any},
): boolean => Object.keys(constraints).every(name => runValidator(name, constraints[name], obj));
